import { render, staticRenderFns } from "./USDT.vue?vue&type=template&id=5ba640f2&scoped=true"
import script from "./USDT.vue?vue&type=script&lang=js"
export * from "./USDT.vue?vue&type=script&lang=js"
import style0 from "./USDT.vue?vue&type=style&index=0&id=5ba640f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba640f2",
  null
  
)

export default component.exports